import LegalDocument from './LegalDocument';
import { TERMS, TERMS_VERSION } from '@/pages/Signup/termsContent';

/** 이용약관 페이지 (footer /terms-of-service). 회원가입의 '서비스 이용약관' 본문을 재사용. */
const TermsOfService = () => {
    const service = TERMS.find((t) => t.id === 'service');
    return (
        <LegalDocument
            title="서비스 이용약관"
            version={TERMS_VERSION}
            content={service?.content ?? '약관 내용을 불러올 수 없습니다.'}
        />
    );
};

export default TermsOfService;
